export enum ContactLinkType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}
